import React, { useState, useEffect } from 'react';
import './AnimatedComponentWrapper.css';

const AnimatedComponentWrapper = ({ 
    isLoading, 
    children, 
    loadingComponent,
    animationType = 'fade' 
}) => {
    const [showContent, setShowContent] = useState(false);
    
    useEffect(() => {
        if (!isLoading) {
            // Delay para permitir que termine la animación de loading
            setTimeout(() => setShowContent(true), 150);
        } else {
            setShowContent(false);
        }
    }, [isLoading]);
    
    return (
        <div className="animated-wrapper position-relative h-100">
            {/* Loading State */}
            <div 
                className={`loading-state ${isLoading ? 'visible' : 'hidden'}`}
            >
                {loadingComponent}
            </div>
            
            {/* Content State */}
            <div 
                className={`content-state ${showContent ? 'visible' : 'hidden'}`}
            >
                {children}
            </div>
        </div>
    );
};

export default AnimatedComponentWrapper;